export default __webpack_public_path__ + "static/media/manufacturing.79d01b0f.jpg";